import { useState, useEffect, useRef } from 'react';
import { Text, View } from '@smarterservices/smarter-ui';
import Loader from '@ui/context/session/components/Common/Loader';
import TimeRemaining from '../../Common/TimeRemaining';
import BaseOverlay from './BaseOverlay';
import { getStore } from '../../../stores/StoreContext';

const REMOVAL_COUNTDOWN_SECONDS = 5;

const SessionDisconnected = ({ lastConnectionChange }) => {
  const mustReconnectBy = lastConnectionChange?.metadata?.mustReconnectBy;
  const [hasExpired, setHasExpired] = useState(false);
  const [removalCountdown, setRemovalCountdown] = useState(REMOVAL_COUNTDOWN_SECONDS);
  const countdownRef = useRef(null);

  const handleExpire = () => {
    setHasExpired(true);
  };

  // When the reconnect timer expires, start a 5-second removal countdown
  useEffect(() => {
    if (!hasExpired) return;

    setRemovalCountdown(REMOVAL_COUNTDOWN_SECONDS);

    countdownRef.current = setInterval(() => {
      setRemovalCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          countdownRef.current = null;

          // Trigger the removal event — the VTC session store handles
          // removing the session from the visible grid
          const EventStore = getStore('eventStore');
          EventStore.trigger('onSessionExpiredRemoval');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
        countdownRef.current = null;
      }
    };
  }, [hasExpired]);

  return (
    <BaseOverlay>
      <View as="div" textAlign="center">
        {mustReconnectBy && !hasExpired && (
          <>
            <Loader size="x-small" text="Session Disconnected" />
            <Text as="div" size="small" color="secondary" margin="small none none none">
              Tester must reconnect within <TimeRemaining until={new Date(mustReconnectBy)} onExpires={handleExpire} /> to remain in session.
            </Text>
          </>
        )}
        {hasExpired && (
          <Text as="div" size="small" color="danger" margin="small none none none">
            Reconnect time expired. Removing in {removalCountdown}...
          </Text>
        )}
      </View>
    </BaseOverlay>
  );
};

export default SessionDisconnected;
